<div class="faq-support">
  <cw-markdown
    [markdownText]="rawMarkdown"
    [applyCustomStyle]="false"
  ></cw-markdown>
</div>
